"use client";

import Grid from "@mui/material/Grid";
import SectionCreator from "./default/section-creator";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import React from "react";
import { Product } from "src/lib/fetcher/client";
import ProductItemVertical from "src/lib/components/product-item/vertical";

// =========================================================

export interface VariantProps {
  title: string;
  featuredOption?: string;
}
const ProductListSection: React.FC<VariantProps> = ({ title, featuredOption }) => {
  const products = SalifyFallback.useSelect<Product[]>("output:products.data");
  return (
    <SectionCreator title={title} seeMoreLink="/collection" bgColor={"inherit"}>
      <Grid container mb={-0.5} spacing={2.5}>
        {products &&
          products.map((item, ind) => (
            <Grid key={ind} item md={3} sm={4} xs={6}>
              <ProductItemVertical {...item} featuredOption={featuredOption} />
            </Grid>
          ))}
      </Grid>
    </SectionCreator>
  );
};

export default ProductListSection;
